import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SessionInfoDto } from '../../../models/chat/chat-session.models';

@Injectable({ providedIn: 'root' })
export class ChatSessionUiService {
  // Estado para la lista de sesiones y la sesión seleccionada
  sessions$ = new BehaviorSubject<SessionInfoDto[]>([]);
  selectedSessionId$ = new BehaviorSubject<string | null>(null);
  sessionTurns$ = new BehaviorSubject<any[]>([]); // Se tipificará cuando se defina el modelo

  setSessions(sessions: SessionInfoDto[]) {
    this.sessions$.next(sessions);
  }

  setSelectedSessionId(sessionId: string | null) {
    this.selectedSessionId$.next(sessionId);
  }

}
